module.exports = __webpack_public_path__ + "static/images/challenge.ddc97c9248d0889aabddfe2f5d1d00e8.jpg";